module.exports = __webpack_public_path__ + "static/img/jingxuanmingcha.7bbbcb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type/daohang/jingxuanmingcha.png
// module id = O5zS
// module chunks = 12